import { Action } from '@ngrx/store';
import { PaymentStatusModel } from '../reducers/paymentStatus';

export enum PaymentStatusActionTypes {
  paymentStatusRequested = '[PaymentStatus] Payment Status Requested',
  paymentStatusLoaded = '[PaymentStatus] Payment Status Loaded',
  paymentStatusLoadFailed = '[PaymentStatus] Payment Status Load Failed',
}

export class PaymentStatusRequested implements Action {
  readonly type = PaymentStatusActionTypes.paymentStatusRequested;

  constructor(public payload: number | string) {}
}

export class PaymentStatusLoaded implements Action {
  readonly type = PaymentStatusActionTypes.paymentStatusLoaded;

  constructor(public payload: { paymentStatus: PaymentStatusModel }) {}
}
export class PaymentStatusLoadFailed implements Action {
  readonly type = PaymentStatusActionTypes.paymentStatusLoadFailed;

  constructor(public payload) {}
}

export type PaymentStatusActions =
  | PaymentStatusRequested
  | PaymentStatusLoaded
  | PaymentStatusLoadFailed;
